import { render, staticRenderFns } from "./ModalPagamentosAluno.vue?vue&type=template&id=d80bf14a&"
import script from "./ModalPagamentosAluno.vue?vue&type=script&lang=js&"
export * from "./ModalPagamentosAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports